import Loader from "shared-components-package/dist/components/loader";
// import LoginForm from "src/components/login-form";
import { useDispatch, useSelector } from "react-redux";
// import LanguageSelector from "src/components/topbar/languageSelector";
import { ReactComponent as ImedilLogo } from "src/assets/static/images/login-imedil-logo.svg";
import Footer from "src/components/footer";
import { useLocation } from "react-router";
import { useEffect, useRef, useState } from "react";
import IdentomatResult from "src/components/login-form/identomat-result";
import GeoIcon from "src/assets/static/images/geoLangIcon.svg";
import EngIcon from "src/assets/static/images/icon-eng.svg";
import { ReactComponent as DownArrow } from "src/assets/static/images/chevron-down (1).svg";
import actions from "src/store/common/actions";
import { Link } from "react-router-dom";
import { PROFILE_PAGE_URL } from "src/containers/layout";
import LoginFormReworked from "src/components/login-form-reworked";
const Login = () => {
  const location = useLocation();
  const [sessionToken, setSessionToken] = useState("");
  const isIdentomat = useSelector((state) => state.auth?.isIdentomat);
  // const [isIdentomat, setIsIdentomat] = useState(false);
  const [showLang, setShowLang] = useState(false);
  const dropdown3Ref = useRef(null);
  const lang = useSelector((state) => state.common.lang);
  const dispatch = useDispatch();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionToken = queryParams.get("session_token");
    setSessionToken(sessionToken);
  }, [location.search]);

  return (
    <div className="login" style={{ overflowX: "hidden" }}>
      <div className="login-header row">
        <Link to={PROFILE_PAGE_URL}>
          <div className="text-center mx-auto col-12 col-md-10 order-md-1 order-2">
            <ImedilLogo className="login-logo mt-3" />
          </div>
        </Link>
        <div
          className="dropdown ms-auto col-12 col-md-2 order-md-2 order-1 me-4 mb-3"
          ref={dropdown3Ref}
        >
          <button
            className="dropbtn position-absolute end-0"
            onClick={() => setShowLang((item) => !item)}
          >
            <img
              src={lang !== "ge" ? EngIcon : GeoIcon}
              alt=""
              className="pe-2"
            />
            {lang === "ge" ? "ქარ" : "Eng"}
            <DownArrow className="ms-2" />
          </button>
          {showLang && (
            <div
              className="dropdown-content end-0 mt-4"
              style={{ minWidth: "130px", marginRight: "-4px" }}
            >
              <a
                className="text-center"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setShowLang(false);
                  dispatch(actions.setLanguage(lang === "ge" ? "en" : "ge"));
                  localStorage.setItem("lang", lang === "ge" ? "en" : "ge");
                }}
              >
                <img
                  src={lang === "ge" ? EngIcon : GeoIcon}
                  alt=""
                  className="pe-2"
                />
                {lang !== "ge" ? "ქარ" : "Eng"}
              </a>
            </div>
          )}
        </div>
      </div>
      <div className="login-main col-12 pb-5">
        <Loader
          render={() => (
            <>
              <div className="login-main-form">
                <div className="login-form">
                  {sessionToken === null && (
                    <LoginFormReworked {...{ isIdentomat }} />
                  )}
                  {sessionToken?.length > 0 && (
                    <IdentomatResult {...{ sessionToken, isIdentomat }} />
                  )}
                </div>
              </div>
            </>
          )}
        />
      </div>
      <Footer />
    </div>
  );
};

export default Login;
